export default __webpack_public_path__ + "static/media/university-of-manila-min.9015bf10.png";